import { render, staticRenderFns } from "./DrawActivity.vue?vue&type=template&id=6a64fd66&scoped=true&"
import script from "./DrawActivity.vue?vue&type=script&lang=js&"
export * from "./DrawActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a64fd66",
  null
  
)

export default component.exports